import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../translations/translations';
import AnimatedSection from './AnimatedSection';
import { HandDrawnDivider, VintageFrame } from './DecorativeElements';

const Services = () => {
  const { language } = useLanguage();
  const t = translations[language];
  const venueAmenities = t.services.amenityList;
  const additionalOfferings = t.services.additionalList;

  return (
    <section id="services" className="section-padding bg-warm-beige texture-overlay">
      <div className="container mx-auto">
        <AnimatedSection animation="fadeInUp">
          <div className="text-center mb-16">
            <h2 className="section-heading">{t.services.title}</h2>
            <p className="text-xl font-serif text-terracotta italic mb-4">
              {t.services.subtitle}
            </p>
            <HandDrawnDivider />
          </div>
        </AnimatedSection>

        <div className="grid md:grid-cols-2 gap-12 mb-16">
          <AnimatedSection animation="slideInLeft" delay={200}>
            <VintageFrame>
              <div className="bg-rustic-cream p-8 rounded-lg shadow-layered border-2 border-latte">
                <h3 className="text-3xl font-serif text-deep-brown mb-6">{t.services.amenities}</h3>
                <ul className="space-y-3">
                  {venueAmenities.map((amenity, index) => (
                    <li key={index} className="flex items-start">
                      <span className="text-terracotta mr-3 mt-1">✦</span>
                      <span className="text-deep-brown font-body text-lg">{amenity}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </VintageFrame>
          </AnimatedSection>

          <AnimatedSection animation="slideInRight" delay={300}>
            <VintageFrame>
              <div className="bg-rustic-cream p-8 rounded-lg shadow-layered border-2 border-latte">
                <h3 className="text-3xl font-serif text-deep-brown mb-6">{t.services.additional}</h3>
                <ul className="space-y-3">
                  {additionalOfferings.map((offering, index) => (
                    <li key={index} className="flex items-start">
                      <span className="text-terracotta mr-3 mt-1">✦</span>
                      <span className={`font-body text-lg ${
                        offering === t.services.optional ? 'font-bold text-terracotta' : 'text-deep-brown'
                      }`}>
                        {offering}
                      </span>
                    </li>
                  ))}
                </ul>
              </div>
            </VintageFrame>
          </AnimatedSection>
        </div>

        <AnimatedSection animation="fadeInUp" delay={400}>
          <div className="text-center mt-16">
            <h3 className="text-3xl font-serif text-deep-brown mb-4">{t.services.accommodations}</h3>
            <p className="text-lg font-body text-deep-brown mb-8">
              {t.services.accommodationsDesc}
            </p>
            <div className="max-w-4xl mx-auto rounded-lg overflow-hidden shadow-layered-lg border-4 border-latte">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4199.179112388871!2d-97.21648822358532!3d32.46315427379634!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x864e5d86c4cfeb2d%3A0x8053e80ecbfd089f!2sHaros%20Event%20Center!5e1!3m2!1sen!2sus!4v1770829221810!5m2!1sen!2sus"
                width="100%"
                height="450"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                className="w-full"
                title="Haros Event Center Location"
              />
            </div>
          </div>
        </AnimatedSection>
      </div>
    </section>
  );
};

export default Services;
